var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-empty',{attrs:{"image":_setup.Empty.PRESENTED_IMAGE_SIMPLE}})
}
var staticRenderFns = []

export { render, staticRenderFns }